export enum BodyType {

    AverageMale,
    AverageFemale,
    AverageNonBinary
}